import React, { useEffect, useState } from 'react';

const Notification = ({ id, message, type = 'info', onClose, duration = 4000 }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        // Start exit animation
        setIsExiting(true);
        // Wait for animation to complete before removing
        setTimeout(() => {
          onClose(id);
        }, 400); // Match the CSS animation duration
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose(id);
    }, 400);
  };

  const icons = {
    info: '[i]',
    success: '[✓]',
    warning: '[!]',
    error: '[X]'
  };

  return (
    <div className={`notification notification-${type} ${isExiting ? 'notification-exit' : ''}`}>
      <div className="notification-icon">{icons[type]}</div>
      <div className="notification-content">
        <p>{message}</p>
      </div>
      <button className="notification-close" onClick={handleClose}>
        ✕
      </button>
    </div>
  );
};

const NotificationContainer = ({ notifications, onClose }) => {
  return (
    <div className="notification-container">
      {notifications.map((notif) => (
        <Notification
          key={notif.id}
          id={notif.id}
          message={notif.message}
          type={notif.type}
          onClose={onClose}
          duration={notif.duration}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;
